<template>
    <div class="forex-index">
        <page-navigate></page-navigate>

        <div class="forex-wrapper cn">
            <forexMenu />
            <div class="forex-wrapper-body">
                <div id="search-box-index">

                    <div class="ebc-tabs-box">
                        <div class="ebc-tabs no-scrollbar">
                            <a :href="'/jinrong/' + nav.route_en + '/'" class="ebc-tab-item "
                                :class="{ 'ebc-tab-item-selected': isSelected(nav) }"
                                v-for="(nav, index) in sub_nav_items" :key="nav.id">
                                <span v-if="index == 0">全部</span>
                                <span v-else>{{ nav.name }}</span>
                            </a>
                        </div>
                    </div>
                    <section class="section1">
                        <div class="knowledge-list" v-loading="loading">

                            <div class="knowledge-item" v-for="item in list" :key="item.id">
                                <a :href="item.url.replace('/zh-cn', '')">
                                    <img class="knowledge-item-img" :src="item.thumbnail" :alt="item.post_title" />
                                </a>
                                <div class="knowledge-item-content">
                                    <a :href="item.url.replace('/zh-cn', '')"
                                        class="knowledge-item-title">{{ item.post_title }}</a>
                                    <div class="knowledge-item-publish-time">
                                        {{ formateTime(item.update_time) }}
                                    </div>
                                    <div class="knowledge-item-intro">{{ item.post_excerpt }}</div>
                                </div>
                            </div>
                             <!-- 加载状态提示 -->
                            <div v-if="loading && list.length > 0" class="load-more-tip">加载中...</div>
                            <div v-if="!hasMore && list.length > 0" class="load-more-tip">没有更多内容了</div>
                        </div>
                    </section>
                    <!-- <div class="ebc-page-pagination">
                        <el-pagination layout="prev, pager, next" :total="total" :current-page="page"
                            :page-size="pageSize" :pager-count="5" hide-on-single-page
                            @current-change="handleCurrentChange">
                        </el-pagination>
                    </div> -->
                </div>
            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>
<script>
import moment from 'moment';
import forexMenu from '../../components/forex-menu/forex-menu.vue';
import { getAcademyList } from '../../serve/forex.js';

export default {
    components: {
        forexMenu
    },
    data() {
        return {
            total: 0,
            pageSize: 15,
            page: 1,
            list: [],
            sub_nav_items: [],
            loading: false, // 是否正在加载
            hasMore: true, // 是否还有更多数据
            isInit: true   // 首次加载标识（避免 scroll 事件触发初始加载）
        };
    },
    created() {
        console.log("this.$route.name", this.$route.name)
        this.handleEnterSearch()
    },
    mounted() {
        // 处理 tab 自动居中（保留原有逻辑）
        this.scrollToSelectedTab();
        // document.addEventListener("DOMContentLoaded", function () {
        //     const tabsContainer = document.querySelector(".ebc-tabs");
        //     const selectedTab = document.querySelector(".ebc-tab-item-selected");

        //     if (window.innerWidth <= 996 && tabsContainer && selectedTab) {

        //         const containerWidth = tabsContainer.offsetWidth;
        //         const tabOffsetLeft = selectedTab.offsetLeft;
        //         const tabWidth = selectedTab.offsetWidth;
        //         const scrollLeftValue = tabOffsetLeft - (containerWidth / 2) + (tabWidth / 2);

        //         tabsContainer.scrollTo({
        //             left: scrollLeftValue,
        //             behavior: "smooth",
        //         });
        //     }
        // });
        // 监听滚动事件
        window.addEventListener('scroll', this.onScroll);
    },
     beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll);
    },
    methods: {
        scrollToSelectedTab() {
            const tabsContainer = document.querySelector(".ebc-tabs");
            const selectedTab = document.querySelector(".ebc-tab-item-selected");

            if (window.innerWidth <= 996 && tabsContainer && selectedTab) {
                const containerWidth = tabsContainer.offsetWidth;
                const tabOffsetLeft = selectedTab.offsetLeft;
                const tabWidth = selectedTab.offsetWidth;
                const scrollLeftValue = tabOffsetLeft - containerWidth / 2 + tabWidth / 2;

                tabsContainer.scrollTo({
                    left: scrollLeftValue,
                    behavior: "smooth",
                });
            }
        },
        isSelected(nav) {
            return nav.route_en == this.$route.name
        },
        formateTime(time) {
            return moment.unix(new Date(time)).format("YYYY-MM-DD")
        },
        async handleEnterSearch(isLoadMore = false) {
            if (this.loading || (!isLoadMore && !this.isInit)) return;

            this.loading = true;
            try {
                const response = await getAcademyList(this.$route.name, this.page);
                console.log("!!!!!!!!!!",response)
                if (response.status == '200') {
                    const data = response.data.data;
                    this.sub_nav_items = data.sub_nav_items;
console.log("this.list",this.list)
                    if (isLoadMore) {
                        this.list = [...this.list, ...data.list];
                    } else {
                        this.list = data.list;
                        this.isInit = false;
                    }

                    this.total = data.pagination.total;
                    this.hasMore = this.page < data.pagination.last_page;
                } else {
                    this.hasMore = false;
                }
            } catch (err) {
                console.error('加载失败:', err);
                this.hasMore = false;
            } finally {
                this.loading = false;
            }
        },

        // 滚动到底部判断
        onScroll() {
            // 节流：避免频繁触发
            if (this.loading || !this.hasMore) return;

            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const clientHeight = document.documentElement.clientHeight;
            const scrollHeight = document.documentElement.scrollHeight;
            let height  = document.querySelector('.page-footer-wrapper').offsetHeight

            console.log("scrollTop",scrollTop)
             console.log("clientHeight",scrollTop)
             console.log("scrollHeight",scrollHeight)
             console.log("scrollHheighteight",height)
            // 判断是否接近底部（预留 200px 提前加载）
            if (scrollTop + clientHeight >= scrollHeight - 200 -height) {
                this.page += 1;
                this.handleEnterSearch(true); // 标记为加载更多
            }
        },
        handleCurrentChange(page) {
            this.page = page;
            this.handleEnterSearch();
        },
    }
}
</script>

<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");
@import url("../../assets/css/forex/forex-tool.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}

.knowledge-list {
    /* margin-top: 48rem; */
    display: flex;
    flex-direction: column;
    gap: 40rem;
}

.knowledge-item {
    display: flex;
    justify-content: space-between;
    gap: 24rem;
}

.knowledge-item a {
    flex-shrink: 0;
}

.knowledge-item-content {
    position: relative;
    overflow: hidden;
    flex-grow: 1;
}

.knowledge-item-img {
    flex-shrink: 0;
    width: 160rem;
    /* height: 100rem; */
    object-fit: cover;
    border-radius: 8rem;
    background: #dadada;
}

.knowledge-item-title {
    width: 100%;
    color: #232222;
    font-size: 16rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 溢出时显示省略号 */
}

.knowledge-item-title:hover {
    color: #232222;
}

.knowledge-item-publish-time {
    margin-top: 4rem;
    color: #b2afad;
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.knowledge-item-intro {
    margin-top: 12rem;
    color: #6a6967;

    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ebc-page-pagination {
    display: flex;
    justify-content: center;
    margin-top: 50rem;
}
.load-more-tip {
    text-align: center;
    color: #999;
    font-size: 14rem;
    padding: 20rem 0;
}
@media (max-width: 996px) {
    .load-more-tip {
        font-size: 24rem;
    }
    .ebc-tabs {
        margin-top: 20rem;
    }

    .knowledge-list {
        /* margin-top: 74rem; */
        gap: 48rem;
    }

    .forex-title-intro {
        margin-top: 18rem;
    }

    .knowledge-item-img {
        width: 264rem;
        height: 169rem;
    }

    .knowledge-item-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .knowledge-item-title {
        font-size: 32rem;
        white-space: unset;
        display: -webkit-box;
        line-clamp: 2;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .knowledge-item-publish-time {
        font-size: 28rem;
    }

    .knowledge-item-intro {
        display: none;
    }
}
</style>